import state from './module-log-state';
import mutations from './module-log-mutations';
import actions from './module-log-actions';
import getters from './module-log-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state: state,
	mutations: mutations,
	actions: actions,
	getters: getters
};
